// extracted by mini-css-extract-plugin
export var borderRadius = "_be-4";
export var large = "_be-3";
export var logoContainer = "_be-0";
export var nameLogo = "_be-2";
export var small = "_be-1";